import React, { useEffect } from "react";
import { useFormContext } from "../Form/FormContext";

interface FormDataSaverProps {
  storageKey: string;
  debounceMs?: number;
  /** Field names that must never be persisted to storage (e.g. passwords). */
  excludeFields?: string[];
}

const FormDataSaver: React.FC<FormDataSaverProps> = ({
  storageKey,
  debounceMs = 500,
  excludeFields = [],
}) => {
  const { formData } = useFormContext();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Omit sensitive fields before persisting
      const safeData = Object.fromEntries(
        Object.entries(formData).filter(([key]) => !excludeFields.includes(key))
      );
      sessionStorage.setItem(storageKey, JSON.stringify(safeData));
    }, debounceMs);

    return () => clearTimeout(timeoutId);
  }, [formData, storageKey, debounceMs, excludeFields]);

  return null;
};

export default FormDataSaver;
